export default __webpack_public_path__ + "src/images/system_name/2-f4e1b8.png";